import React, { useState } from 'react';

import {
  setCurrentStep,
  setHrData,
  setTestData
} from '../../../redux/Slices/InterviewSlice';
import {
  setPlansPopUpOpen,
  setpopUpPlanMessage
} from '../../../redux/Slices/PaymentsSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/store/hooks';

import { InterviewSetup } from './step1Setup';
import { InterviewSetupStep2 } from './step2Setup';
import Step3SetUP from './step3Setup';

const InterviewInstructionsV2 = ({ isHr }: { isHr: boolean }) => {
  const dispatch = useAppDispatch();
  const { isDriveTest } = useAppSelector(state => state.root.startFulltest);
  const { testData, hrData } = useAppSelector(state => state.root.interview);
  const [currentStep, setCurrentSetUpStep] = useState(1);
  const [micPermission, setMicPermission] = useState(false);

  const steps = [
    { id: 1, label: 'Permission' },
    { id: 2, label: 'Setup' },
    { id: 3, label: 'Interview' }
  ];

  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentSetUpStep(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentSetUpStep(prev => prev - 1);
    }
  };

  const handleInterviewStart = async () => {
    try {
      if (isHr && !isDriveTest) {
        dispatch(setCurrentStep('interview'));
      } else {
        if (isDriveTest) {
          if (isHr) {
            dispatch(setTestData(hrData));
          } else {
            dispatch(setHrData(testData?.hrTest));
            dispatch(setTestData(testData?.interviewTest));
          }
        }
        dispatch(setCurrentStep('interview'));
      }
    } catch (error: any) {
      if (error.status === 402) {
        const message = error?.data?.message;
        dispatch(setpopUpPlanMessage(message));
        dispatch(setPlansPopUpOpen(true));
      }
      console.error(error, 'Failed to Genrate Test');
    }
  };

  const renderContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <InterviewSetup
            micPermission={micPermission}
            setMicPermission={setMicPermission}
          />
        );
      case 2:
        return <InterviewSetupStep2 />;
      case 3:
        return (
          <Step3SetUP isHr={isHr} onStartInterview={handleInterviewStart} />
        );
      default:
        return null;
    }
  };

  return (
    <div className='min-h-screen bg-gray-50 md:px-4 md:py-8'>
      <div className='mx-auto w-full max-w-5xl rounded-xl bg-white p-4 shadow-lg md:p-8'>
        {/* Header */}
        <div className='flex flex-col justify-between gap-5 md:mb-5 md:flex-row'>
          <div>
            <h1 className='text-3xl font-bold text-gray-900'>
              Let&apos;s Get You Set Up
            </h1>
            <p className='mt-2 text-gray-600'>
              We need your camera and microphone to create a realistic interview
              experience
            </p>
          </div>
          {/* Navigation Buttons */}
          <div className='flex items-center gap-3 py-6'>
            {/* <button
              onClick={handlePrevious}
              disabled={currentStep === 1}
              className={`rounded-lg px-6 py-2 text-sm font-medium transition-colors ${
                currentStep === 1
                  ? 'cursor-not-allowed bg-gray-100 text-gray-400'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Previous
            </button> */}

            {currentStep < steps.length && (
              <button
                onClick={handleNext}
                disabled={currentStep === 1 && !micPermission}
                className={`w-full rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 ${currentStep === 1 && !micPermission ? 'cursor-not-allowed opacity-50' : ''}`}
              >
                Next
              </button>
            )}
          </div>
        </div>

        {/* Progress Steps */}
        <div className='mb-10'>
          <div className='flex items-center justify-between'>
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div className='flex flex-col items-center'>
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold transition-all
                    ${
                      currentStep >= step.id
                        ? 'bg-blue-600 text-white shadow-md'
                        : 'bg-gray-200 text-gray-500'
                    }
                    ${currentStep === step.id ? 'ring-4 ring-blue-100' : ''}`}
                  >
                    {step.id}
                  </div>
                  <span
                    className={`mt-2 text-sm font-medium transition-colors ${
                      currentStep >= step.id ? 'text-blue-600' : 'text-gray-500'
                    }`}
                  >
                    {step.label}
                  </span>
                </div>

                {index < steps.length - 1 && (
                  <div className='mx-4 flex-1'>
                    <div
                      className={`h-1 rounded-full transition-all ${
                        currentStep > step.id ? 'bg-blue-600' : 'bg-gray-200'
                      }`}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className='mb-8'>{renderContent()}</div>
      </div>
    </div>
  );
};

export default InterviewInstructionsV2;
